import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClipboardCheck, ClipboardList, Users, CalendarCheck } from "lucide-react";
import SKEventCoverageTab from "@/components/admin/scorekeepers/SKEventCoverageTab";
import SKAssignmentsTab from "@/components/admin/scorekeepers/SKAssignmentsTab";
import SKRosterTab from "@/components/admin/scorekeepers/SKRosterTab";
import SKAvailabilityTab from "@/components/admin/scorekeepers/SKAvailabilityTab";

const EventManagementScorekeepers: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <ClipboardCheck className="h-6 w-6 text-secondary" />
          Scorekeepers
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage the scorekeeper roster, assign them to events, and track availability and pay.
        </p>
      </div>

      <Tabs defaultValue="coverage">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="coverage" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ClipboardList className="h-4 w-4" />
            <span className="hidden sm:inline">Event Coverage</span>
            <span className="sm:hidden">Coverage</span>
          </TabsTrigger>
          <TabsTrigger value="assignments" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Users className="h-4 w-4" />
            <span className="hidden sm:inline">Assignments</span>
            <span className="sm:hidden">Assign</span>
          </TabsTrigger>
          <TabsTrigger value="roster" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ClipboardCheck className="h-4 w-4" />
            <span className="hidden sm:inline">Scorekeeper Roster</span>
            <span className="sm:hidden">Roster</span>
          </TabsTrigger>
          <TabsTrigger value="availability" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <CalendarCheck className="h-4 w-4" />
            <span className="hidden sm:inline">Availability</span>
            <span className="sm:hidden">Avail</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="coverage" className="mt-6"><SKEventCoverageTab /></TabsContent>
        <TabsContent value="assignments" className="mt-6"><SKAssignmentsTab /></TabsContent>
        <TabsContent value="roster" className="mt-6"><SKRosterTab /></TabsContent>
        <TabsContent value="availability" className="mt-6"><SKAvailabilityTab /></TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementScorekeepers;
